/** P&L direct cost lines from discharged IPD patient expenses (hover breakdown). */
export const PNL_IPD_DIRECT_COST_LINE_IDS = ['A19', 'A21', 'A23', 'A25', 'A27'] as const;

export type PnlIpdDirectCostLineId = (typeof PNL_IPD_DIRECT_COST_LINE_IDS)[number];

export function isPnlIpdDirectCostLineId(lineId: string): lineId is PnlIpdDirectCostLineId {
  return (PNL_IPD_DIRECT_COST_LINE_IDS as readonly string[]).includes(lineId);
}

export function pnlIpdDirectCostHint(lineId: string): { note?: string } | null {
  if (!isPnlIpdDirectCostLineId(lineId)) return null;
  switch (lineId) {
    case 'A27':
      return { note: 'Hover a month for patient and financing-partner breakdown.' };
    default:
      return { note: 'Hover a month for per-IPD / patient breakdown.' };
  }
}
